import layoutList from '@/layouts/layout-list.vue'

export default [
  {
    path: '',
    redirect: '',
    component: layoutList,
    /* hidden: true, */
    children: [{
      path: '/orders',
      name: 'orders',
      component: resolve => require.ensure([], () => resolve(require('@/views/list/index.vue')), 'orders'),
      meta: { title: '列表页', icon: '' }
    }]
  }
]
